import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { updateResponses } from '../../actions'
import styles from './Interaction.css'

import QuizWrapper from '../QuizWrapper'
import QuestionBlock from '../QuestionBlock'
import LikertScale from '@healthwise-ui/core/LikertScale'
import QuestionMultChoiceSingleAnswer from '../QuestionMultChoiceSingleAnswer'
import Textarea from '@healthwise-ui/core/TextArea'

class Interaction extends Component {
  render () {
    const item = this.props.item

    this.handleLikertAnswer = this.handleLikertAnswer.bind(this)
    this.handleMultChoiceAnsweredQuestion = this.handleMultChoiceAnsweredQuestion.bind(this)
    this.handleMultChoiceAnsweredQuizQuestion = this.handleMultChoiceAnsweredQuizQuestion.bind(this)
    this.handleOpenQuestion = this.handleOpenQuestion.bind(this)

    return this.renderInteractionType(item)
  }

  handleLikertAnswer (e, selectedValue, answerId) {
    const response = {
      id: e.target.name,
      answerId: answerId,
      type: this.props.item.type,
      // this emulates the format of the other answers, so the same action can handle it easily
      answers: [{
        id: answerId,
        answer: selectedValue
      }]
    }

    this.props.updateResponses('LikertResponse', response)
  }

  handleMultChoiceAnsweredQuestion (event) {
    const response = {
      'id': event.target.name,
      'answerId': event.target.value,
      'answers': this.props.item.answers,
      'question': this.props.item.question,
      'type': this.props.item.type
    }

    this.props.updateResponses('OpinionResponse', response)
  }

  handleMultChoiceAnsweredQuizQuestion (event) {
    const response = {
      'id': event.target.name,
      'answerId': event.target.value,
      'answers': this.props.item.answers,
      'question': this.props.item.question,
      'type': this.props.item.type
    }

    this.props.updateResponses('QuizResponse', response)
  }

  handleOpenQuestion (e) {
    const props = this.props
    const response = {
      id: props.item.id,
      answerId: props.item.answerId,
      type: props.item.type,
      // this emulates the format of the other answers, so the same action can handle it easily
      answers: [{
        id: props.item.answerId,
        answer: e.target.value
      }]
    }

    this.props.updateResponses('LikertResponse', response)
  }

  renderInteractionType (item) {
    const handleLikertAnswer = this.handleLikertAnswer
    let {responseState, onQuestionRender, readonly, ...propArguments} = this.props
    let selectedAnswer = (responseState.responses[item.id] || {answer: {value: null, id: null}}).answer
    let toRender = null

    switch (item.type) {
      case 'hwSingleSelectScale':
        // default render
        toRender = (
          <LikertScale
            id={item.id}
            answerId={item.answerId}
            name={item.id}
            onAnswer={handleLikertAnswer}
            selectedAnswer={selectedAnswer.value}
            readonly={readonly}
            {...propArguments}
          />
        )

        // allow the parent to replace render (in this case -- with "Go back to answer" for unanswered questions on the summary page)
        if (onQuestionRender) {
          const customRender = onQuestionRender(item.id)
          // only custom render if the parent function hands us something
          if (customRender) {
            toRender = customRender
          }
        }

        return (<QuizWrapper>
          <QuestionBlock questionId={item.id} question={item.question}>
            {toRender}
          </QuestionBlock>
        </QuizWrapper>
        )

      case 'hwSingleSelectOpinion':
        // default render
        toRender = (
          <QuizWrapper>
            <QuestionMultChoiceSingleAnswer
              responses={responseState.responses}
              onAnswer={this.handleMultChoiceAnsweredQuestion}
              selectedAnswer={selectedAnswer.id}
              readonly={readonly}
              {...item}
              {...propArguments} />
          </QuizWrapper>
        )

        // allow the parent to replace render (in this case, with "Go back to answer" for unanswered questions on the summary page)
        if (onQuestionRender) {
          const customRender = onQuestionRender(item.id)
          // only custom render if the parent function hands us something
          if (customRender) {
            toRender = (
              <QuizWrapper>
                <div className="hw-esdp-interaction-question-wrapper">
                  <QuestionBlock questionId={item.id} question={item.question}>
                    {customRender}
                  </QuestionBlock>
                </div>
              </QuizWrapper>
            )
          }
        }

        return toRender

      case 'hwSingleSelectQuiz':
        return (
          <QuizWrapper>
            <QuestionMultChoiceSingleAnswer
              responses={responseState.responses}
              selectedAnswer={selectedAnswer.id}
              onAnswer={this.handleMultChoiceAnsweredQuizQuestion}
              readonly={readonly}
              {...item}
              {...propArguments} />
          </QuizWrapper>
        )

      case 'hwOpenQuestion':
        return (
          <QuizWrapper>
            <div className={styles.notes_wrapper}>
              <Textarea
                label={item.question}
                readonly={readonly}
                value={selectedAnswer.value}
                maxCharacters={250}
                onBlur={this.handleOpenQuestion}
                />
            </div>
          </QuizWrapper>
        )

      default:
        throw new Error(`Unknown interaction type: ${item.type}`)
    }
  }

  rawMarkup (markup) {
    return (
      <div dangerouslySetInnerHTML={{ __html: markup }} />
    )
  }
}

Interaction.propTypes = {
  responseState: PropTypes.object,
  updateResponses: PropTypes.func.isRequired,
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    answers: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      answer: PropTypes.string.isRequired,
      correctAnswer: PropTypes.string,
      feedback: PropTypes.string
    })),
    question: PropTypes.string,
    type: PropTypes.oneOf(['hwSingleSelectOpinion', 'hwSingleSelectQuiz', 'hwSingleSelectScale', 'hwOpenQuestion'])
  }).isRequired,
  onQuestionRender: PropTypes.func,
  readonly: PropTypes.bool
}

export default connect((state) => state, {updateResponses})(Interaction)



// WEBPACK FOOTER //
// /src/~/@healthwise/enhanced-shared-decision-point/components/Interaction/index.js